import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import SEO from '../components/common/SEO';
import PageContentBlocks from '../components/common/PageContentBlocks';
import usePageContent from '../hooks/usePageContent';
import { publicAPI } from '../services/api';

export default function ContactPage() {
  const { t, i18n } = useTranslation();
  const { blocks } = usePageContent('contact', i18n.language);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await publicAPI.contact(form);
      toast.success('Message sent! We will get back to you soon.');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title={t('contact.title')} />
      <section className="py-12 px-4 max-w-2xl mx-auto">
        <h1 className="section-title text-center mb-8">{t('contact.title')}</h1>
        <PageContentBlocks blocks={blocks} className="mb-8" />
        <form onSubmit={handleSubmit} className="card space-y-4">
          <input className="input-field" placeholder={t('contact.name')} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
          <input type="email" className="input-field" placeholder={t('contact.email')} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          <input className="input-field" placeholder={t('contact.subject')} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required />
          <textarea className="input-field min-h-[120px]" placeholder={t('contact.message')} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
          <button type="submit" disabled={loading} className="btn-primary w-full">{loading ? '...' : t('contact.send')}</button>
        </form>
      </section>
    </>
  );
}
